import AutoComplete from '@nile/banyan/src/Pebbles/autocomplete';
import { processData } from '@nile/banyan/src/Utils/autocomplete';
import { BoxContainer, SrcInfoContainer } from '@nile/banyan/src/Utils/style';
import {
  getTranslatedText,
  AccessControl,
  DeleteModal,
  CascadeCard,
  StatusTag
} from '@nile/components';
import { TEMPLATE_TYPES } from '@nile/banyan/src/Constants/notifications';
import {
  Badge,
  Button,
  ButtonGroup,
  Heading,
  ResourceItem,
  ResourceList,
  TextStyle
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { dompurifier } from '@nile/components/src/Utils/helpers';

class ReplyCascade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
      value: [],
      templates: props.data ? props.data : [],
      selectedItems:
        props.data.length > 0
          ? [this.props?.selectedReplyTemplate?.id || props.data[0].id]
          : [],
      selectedTemplate: this.props?.selectedReplyTemplate || null,
      uioptions: []
    };
  }

  componentDidMount() {
    if (this.props.data.length > 0) {
      const selected = this.props.selectedReplyTemplate
        ? this.props.selectedReplyTemplate
        : this.props.data[0];

      this.renderSubItem(selected);

      if (this?.props?.updateSelectedReplyTemplate) {
        this.props.updateSelectedReplyTemplate(selected);
      }
    }
  }
  componentDidUpdate() {
    if (this?.props?.selectedReplyTemplate) {
      if (
        this?.props?.selectedReplyTemplate !== this?.state?.selectedTemplate
      ) {
        this.setState({
          selectedTemplate: this.props.selectedReplyTemplate,
          selectedItems: [this.props.selectedReplyTemplate.id]
        });
      }
    }
  }

  setSelectedItems = (selectedItem) => {
    if (selectedItem.length > 0) {
      this.setState({ selectedItems: [selectedItem[selectedItem.length - 1]] });
      const { templates } = this.state;
      const item = templates.find((item) => {
        return item.id === selectedItem[selectedItem.length - 1];
      });
      this.renderSubItem(item);

      if (this?.props?.updateSelectedReplyTemplate) {
        this.props.updateSelectedReplyTemplate(item);
      }
    }
  };

  renderSubItem = (item) => {
    this.setState({ selectedTemplate: item });
  };

  deleteReplyTemplate = (id) => {
    this.props.deleteReplyTemplate({
      variables: {
        notificationTemplateType:
          this.props?.templateType || TEMPLATE_TYPES.reply,
        templateId: id
      }
    });
  };

  handleReplyChange = (selectedItem) => {
    this.setState({ selectedItems: [selectedItem.id] });
    this.renderSubItem(selectedItem);

    if (this?.props?.updateSelectedReplyTemplate) {
      this.props.updateSelectedReplyTemplate(selectedItem);
    }
  };

  isSideConversationTemplate =
    this.props?.templateType === TEMPLATE_TYPES.sideConversation;

  render() {
    const { selectedTemplate, templates, selectedItems } = this.state;
    const { intl, disabledDelete = false, editComponent = null } = this.props;

    const templateName = this.isSideConversationTemplate
      ? selectedTemplate?.subject || selectedTemplate?.name
      : selectedTemplate?.name;

    const processedAllItems = processData(templates, 'templateId');

    return (
      <div className="full-height">
        <BoxContainer className="fx full-height white-transparent-bg">
          <div className="fx full-height full-width">
            <div className="fx no-scroll white-transparent-bg w30 border-right p20">
              <div className="full-width fx col">
                <div className="sticky-search">
                  <AutoComplete
                    options={processedAllItems}
                    handleChange={this.handleReplyChange}
                  />
                </div>
                <div className="cascade-list f11 scroll py-10 ch-50">
                  <ResourceList
                    items={templates}
                    selectedItems={selectedItems}
                    onSelectionChange={this.setSelectedItems}
                    renderItem={(item) => {
                      const { id, name } = item;
                      return (
                        <ResourceItem
                          id={id}
                          accessibilityLabel={`View details for ${name}`}
                        >
                          <div className="fw flex list-item center">
                            <TextStyle variation="strong">{name} </TextStyle>
                            {item.uioptions && item.uioptions.length > 0 ? (
                              <div className="iconHolder">
                                <SVGIcon name="ArrowRight" />
                              </div>
                            ) : (
                              <div></div>
                            )}
                            {/* An user experience difference by showing default tag in the list itself instead of the right detail pane. this will
                            be a common thing in the template we moved for cascade containers. We'll use isDefault instead of defaultTemplate */}
                            {item.defaultTemplate && (
                              <StatusTag
                                className="ml-20 f-12"
                                statusObject={{
                                  color: '#ECECEC',
                                  fontColor: '#000000'
                                }}
                              >
                                <div className="flex center uppercase">
                                  <FormattedMessage id="admin.default.tag" />
                                </div>
                              </StatusTag>
                            )}
                          </div>
                        </ResourceItem>
                      );
                    }}
                  />
                </div>
              </div>
            </div>
            {selectedTemplate && (
              <div className="fx p2040 scroll w70">
                <div className="full-width">
                  <div className="flex actr m-0">
                    <div className="fx2">
                      <Heading element="h2">{templateName}</Heading>
                    </div>
                    <div
                      superid="rtOuterActions"
                      className="Reply-Templates-Actions"
                    >
                      {!this.props?.isRunbookTemplate && (
                        <ButtonGroup>
                          {/* Restrict delete for default templates. */}
                          {!selectedTemplate?.defaultTemplate &&
                            !disabledDelete && (
                              <AccessControl
                                roleToCheck={
                                  this.props?.deleteRoleToCheck ||
                                  'replyTemplate.delete'
                                }
                                render={
                                  <DeleteModal
                                    description={getTranslatedText(
                                      intl,
                                      'admin.replyTemplates.delete.confirm'
                                    )}
                                    id="deleteTemplateBtn"
                                    handleDeleteConfirmation={() =>
                                      this.deleteReplyTemplate(
                                        selectedTemplate.id
                                      )
                                    }
                                    title={getTranslatedText(
                                      intl,
                                      'admin.replyTemplates.delete.header'
                                    )}
                                  />
                                }
                              />
                            )}
                          <AccessControl
                            roleToCheck={
                              this.props?.editRoleToCheck ||
                              'replyTemplate.edit'
                            }
                            render={
                              editComponent ? (
                                editComponent(selectedTemplate)
                              ) : (
                                <Button
                                  secondary
                                  icon={<SVGIcon name="Edit" />}
                                  url={
                                    '#/onboard/reply/' +
                                    selectedTemplate.id +
                                    '/edit'
                                  }
                                />
                              )
                            }
                          />
                        </ButtonGroup>
                      )}
                    </div>
                  </div>
                  <div className="ch-50 scroll pt10 pb10">
                    <>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: dompurifier(selectedTemplate?.content)
                        }}
                      />
                      <div className="mt-10 fx wrap g10">
                        {selectedTemplate?.attachmentList?.map((item) => (
                          <Badge>
                            <SVGIcon name="FileAttachment" />
                            {item?.originalFileName}
                          </Badge>
                        ))}
                      </div>
                    </>
                  </div>
                </div>
              </div>
            )}
          </div>
        </BoxContainer>
      </div>
    );
  }
}

export default injectIntl(ReplyCascade);
